<template>
  <span class="mail-reader__recipient-pill-wrap">
    <span class="mail-reader__recipient-pill">
      <span
        class="mail-reader__avatar mail-reader__avatar--small"
        :style="recipientAvatarStyle(recipient.email)"
        aria-hidden="true"
      >
        {{ nameInitials(displayName, '?') }}
      </span>
      <span class="mail-reader__recipient-name" :title="recipient.email">{{ displayName }}</span>
      <button
        type="button"
        class="mail-reader__recipient-copy-btn"
        :title="copied ? 'Copied' : recipient.email"
        :aria-label="copied ? 'Copied' : `Copy ${recipient.email}`"
        @click.stop="copyEmail"
      >
        <i :class="copied ? 'bi bi-check2' : 'bi bi-copy'" aria-hidden="true"></i>
      </button>
    </span>
  </span>
</template>

<script>
import {
  nameInitials,
  recipientAvatarStyle,
  recipientDisplayName,
} from '@/modules/vendor/utils/splitPanelUtils';

export default {
  name: 'MailRecipientPill',
  props: {
    recipient: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      copied: false,
      copiedTimer: null,
    };
  },
  computed: {
    displayName() {
      return recipientDisplayName(this.recipient);
    },
  },
  beforeUnmount() {
    this.clearCopiedTimer();
  },
  methods: {
    nameInitials,
    recipientAvatarStyle,
    async copyEmail() {
      const email = this.recipient?.email;
      if (!email) return;

      let ok = false;
      try {
        if (navigator.clipboard?.writeText) {
          await navigator.clipboard.writeText(email);
          ok = true;
        }
      } catch {
        ok = false;
      }

      if (!ok) {
        const textArea = document.createElement('textarea');
        textArea.value = email;
        textArea.style.position = 'fixed';
        textArea.style.left = '-9999px';
        document.body.appendChild(textArea);
        textArea.select();
        try {
          ok = document.execCommand('copy');
        } catch {
          ok = false;
        }
        document.body.removeChild(textArea);
      }

      if (!ok) return;

      this.copied = true;
      this.clearCopiedTimer();
      this.copiedTimer = setTimeout(() => {
        this.copied = false;
        this.copiedTimer = null;
      }, 1500);
    },
    clearCopiedTimer() {
      if (this.copiedTimer) {
        clearTimeout(this.copiedTimer);
        this.copiedTimer = null;
      }
    },
  },
};
</script>
